// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__NiO1M","range":"MonthRangeSwitch_range__23umS","disabled":"MonthRangeSwitch_disabled__1CdEO"};